export const URL = 'http://mariahormessiah.com/';
export const TWEET = '#Christmas is about two people: #JesusChrist and #MariahCarey. But who’s your #Xmas no1? Play the #quiz to find out https://mariahormessiah.com';
export const HASHTAGS = '#quiz #mariahcarey';



/** WEBPACK FOOTER **
 ** ./src/js/constants/social.js
 **/